<template>
    <page>
        <module title="商城配置">
            <c-form ref="form">
                <c-form-item type="input" label="客服电话" name="CUSTOMER_SERVICE_PHONE"   ></c-form-item>
                <c-form-item type="input" label="联系邮箱" name="CUSTOMER_SERVICE_EMAIL"   ></c-form-item>
                <c-form-item type="editor" label="PC登录页底部导航" name="PC_BOTTOM_NAV"  ></c-form-item>
                <c-form-item type="editor" label="PC页面底部通用导航" name="COMMON_NAV"   ></c-form-item>

            </c-form>

            <template slot="button">
                <c-button size="m" power="b_mall_config_edit" @click="save()">保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>

    export default {
        name: 'm_mall_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                switchOptions: [{
                    name: '开',
                    value: 'ON'
                }, {
                    name: '关',
                    value: 'OFF'
                }],
            }
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                            json[item.config_item_code] = item.config_item_value;
                        });
                        this.$refs.form.set(json);

                    }
                });
            },


            save() {
                this.$refs.form.submit({
                    url: '/platform_config/edit',
                    dataFormatter: data => {
                        let arr = [];
                        for (let key in data) {
                            arr.push({
                                config_item_code: key,
                                config_item_value: data[key] ? data[key].toString() : ''
                            });
                        }
                        return {
                            platform_config_list: arr
                        };
                    },
                    success: () => {
                        this.$message({
                            text: '操作成功'
                        });

                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .box {
    padding: 15px;
    background: #f9f8fb;
  }

  .product {
    position: relative;
    width: 90px;
    height: 90px;
    border: 1px solid #DDDDDD;
    margin-right: 15px;
    margin-top: 15px;
    background: #fff;
    box-sizing: border-box;

    video {
      width: 100%;
      height: 100%;
      background: #000;
    }

    a {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      font-size: 12px;
      color: #fff;
      background: #FF1010;
    }

    &-list {
      margin-top: -15px;
    }

    &-add {
      font-size: 20px;
      color: #ccc;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        border-color: #bbb;
        color: #bbb;
      }
    }
  }
</style>